import React from 'react';
import TextInput, { TextInputProps } from './text-input';

interface NumberInputProps extends TextInputProps {
  min?: number;
  max?: number;
  step?: number;
}

const NumberInput = (props: NumberInputProps) => (
  <TextInput type="number" {...props} />
);

export default NumberInput;
